/** Category keys and label helpers for plan/log calendar filter bars. */

export const PLAN_CATEGORY_KEYS = [
  "annualPhases",
  "training",
  "nutrition",
  "mealPlans",
  "habits",
  "tracking",
  "checkIn",
  "events",
  "goals",
  "period",
];

const PLAN_CATEGORY_I18N_KEYS = {
  annualPhases: "calendar.annualPhase",
  training: "calendar.training",
  nutrition: "calendar.nutrition",
  mealPlans: "calendar.mealPlans",
  habits: "calendar.habits",
  tracking: "calendar.tracking",
  checkIn: "calendar.checkIn",
  events: "calendar.annualEvent",
  goals: "calendar.targetGoal",
  period: "calendar.period",
};

const PLAN_CATEGORY_FALLBACK_LABELS = {
  annualPhases: "Annual Phase",
  training: "Training",
  nutrition: "Nutrition",
  mealPlans: "Meal Plans",
  habits: "Habits",
  tracking: "Tracking",
  checkIn: "Check-In",
  events: "Annual Event",
  goals: "Target Goal",
  period: "Period",
};

export function planCategoryLabel(key, t) {
  return t(PLAN_CATEGORY_I18N_KEYS[key], PLAN_CATEGORY_FALLBACK_LABELS[key]);
}

/** Omit period when Profile → Tasks female cycle tracking is off. */
export function categoryKeysWithPeriod(keys, periodEnabled) {
  if (periodEnabled) return keys;
  return keys.filter((key) => key !== "period");
}

export const LOG_CATEGORY_KEYS = [
  "training",
  "sessionRpe",
  "nutrition",
  "foodLog",
  "habits",
  "period",
  "readiness",
  "vitals",
  "measurements",
  "photos",
  "mealPhotos",
];

const LOG_CATEGORY_I18N_KEYS = {
  period: "calendar.period",
};

const LOG_CATEGORY_FALLBACK_LABELS = {
  period: "Period",
};

export function logCategoryLabel(key, t) {
  if (LOG_CATEGORY_I18N_KEYS[key]) {
    return t(LOG_CATEGORY_I18N_KEYS[key], LOG_CATEGORY_FALLBACK_LABELS[key]);
  }
  return t(`calendar.planView.${key}`, key);
}
